
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 8.44444H6.66667C7.13816 8.44444 7.59035 8.25714 7.92375 7.92375C8.25714 7.59035 8.44444 7.13816 8.44444 6.66667V4M15.5556 4V6.66667C15.5556 7.13816 15.7429 7.59035 16.0763 7.92375C16.4097 8.25714 16.8618 8.44444 17.3333 8.44444H20M20 15.5556H17.3333C16.8618 15.5556 16.4097 15.7429 16.0763 16.0763C15.7429 16.4097 15.5556 16.8618 15.5556 17.3333V20M8.44444 20V17.3333C8.44444 16.8618 8.25714 16.4097 7.92375 16.0763C7.59035 15.7429 7.13816 15.5556 6.66667 15.5556H4","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    